<template>
  <v-sheet
    elevation="0"
    class="px-4 py-3 mt-2"
  >
    <div class="d-flex align-center">
      <div
        v-if="mainPath !== $route.path"
        class="mr-3"
      >
        <v-btn
          v-if="$widget.history.length > 1"
          fab
          x-small
          elevation="0"
          @click="goBack()"
          color="white"
          :loading="loading"
        >
          <Icon
            icon="arrow-left"
            color="primary"
          />
        </v-btn>
      </div>
      <div v-if="title">
        <h3
          v-html="title"
          class="font-weight-regular text-wrap"
        ></h3>
      </div>
    </div>
  </v-sheet>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    title: {
      type: String,
      default: null
    },
    goTo: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mainPath () {
      return this.$store.state.widget.mainPath
    }
  }
})
export default class ViewHeader extends Vue {
  goBack () {
    if (this.goTo) {
      this.$router.replace({ path: this.goTo })
      return false
    }

    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: 'Regresó',
      detail: `El cliente regresó de la vista ${this.$widget.history[0].name} a la vista ${this.$widget.history[1].name}`,
      actionType: 'STAH',
      functionality: 10,
      historyInteractionType: 'OSBACK'
    })

    const path = this.$widget.history[1].path
    this.$widget.history.splice(0, 1)
    this.$router.replace({ path, query: { back: true } })
  }
}
</script>
